if (!customElements.get('media-card-grid')) {
  customElements.define('media-card-grid', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.dialog = this.querySelector('dialog');
      this.videoBody = this.querySelector('[data-grid-video-body]');
      this.addEventListener('click', (event) => {
        const addButton = event.target.closest('[data-grid-add]');
        if (addButton) this.addToCart(addButton);
        const playButton = event.target.closest('[data-grid-play]');
        if (playButton) this.openVideo(playButton);
        if (event.target.closest('[data-grid-close]') || event.target === this.dialog) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.clearVideo(), options);
    }

    disconnectedCallback() {
      this.events?.abort();
      this.dialog?.close();
      this.clearVideo();
    }

    openVideo(button) {
      const template = button.parentElement.querySelector('[data-grid-video]');
      if (!template || this.dialog.open) return;
      // 仅在主动点击后创建视频，避免网格中的视频提前下载或自动播放。
      this.videoBody.replaceChildren(template.content.cloneNode(true));
      this.dialog.showModal();
      this.videoBody.querySelector('video')?.play().catch(() => {});
    }

    clearVideo() {
      this.videoBody?.querySelectorAll('video').forEach(video => video.pause());
      this.videoBody?.replaceChildren();
    }

    async addToCart(button) {
      if (button.disabled) return;
      const status = button.closest('.media-card-grid__card').querySelector('[role="status"]');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = '';
      try {
        // 复用主题的购物车刷新逻辑，同时更新数量并打开购物车抽屉。
        const renderer = customElements.get('product-card')?.prototype;
        if (!renderer?.renderContents || !renderer?.getSectionsToRender) {
          throw new Error('Cart is not ready. Please try again.');
        }
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: button.dataset.variantId, quantity: 1 }],
            sections: renderer.getSectionsToRender().map(section => section.section),
            sections_url: window.location.pathname,
          }),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Unable to add item to cart.');
        renderer.renderContents(result);
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: { product: result.items ? result.items[0] : result },
        }));
      } catch (error) {
        status.textContent = error.message || 'Unable to add item to cart.';
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });
}
